import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {WorkersLayout} from '../../assets/workers/workers-layout'

export const Route = createFileRoute('/_app/workers')({
    component: WorkersRoute,
})

function WorkersRoute() {
    return (
        <Container size="lg" py="xl">
            <WorkersLayout />
        </Container>
    )
}
